export default "__VITE_ASSET__M4dlKczH__"